<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>DOCUMENTOS</b></h5>
        </th>
      </tr>

      <tr>
        <td>
          USUÁRIO REGISTRADO EM CARTÓRIO?
          <b>{{ usuario.registro_cartorio ?? '-' }}</b>
        </td>

        <td>
          TIPO DE CERTIDÃO:
          <b>{{ usuario.tipo_certidao ?? '-' }}</b>
        </td>

        <td colspan="2">
          NOME DO CARTÓRIO:
          <b>{{ usuario.cartorio_nome ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          LIVRO:
          <b>{{ usuario.cartorio_livro ?? '-' }}</b>
        </td>

        <td>
          FOLHA:
          <b>{{ usuario.cartorio_folha ?? '-' }}</b>
        </td>

        <td>
          TERMO/RANI:
          <b>{{ usuario.termo_rani ?? '-' }}</b>
        </td>

        <td>
          TERMO/MATRÍCULA:
          <b>{{ usuario.termo_matricula ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          TERMO DA CERTIDÃO OU MATRÍCULA DAS CERTIDÕES NOVAS:
          <b>{{ usuario.termo_certidao ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          DATA DA EMISSÃO DA CERTIDÃO:
          <b>{{ usuario.certidao_data_emissao ?? '-' }}</b>
        </td>

        <td>
          ESTADO DA CERTIDÃO:
          <b>{{ usuario.certidao_uf ?? '-' }}</b>
        </td>

        <td colspan="2">
          MUNICÍPIO DA CERTIDÃO:
          <b>{{ usuario.certidao_municipio?.nome ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          NECESSIDADE DE PROVIDENCIAR DOCUMENTAÇÃO CIVIL:
          <b>{{ usuario.providenciar_documentacao ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NIS:
          <b>{{ usuario.nis ?? usuario.nao_sabe_nis ?? '-' }}</b>
        </td>

        <td colspan="2">
          CPF:
          <b>{{ usuario.cpf ?? usuario.nao_sabe_cpf ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          ALISTAMENTO MILITAR:
          <b>{{ usuario.alistamento_militar ?? '-' }}</b>
        </td>

        <td>
          PASSAPORTE (ESTRANGEIRO):
          <b>{{ usuario.passaporte ?? '-' }}</b>
        </td>

        <td>
          PIS/PASEP:
          <b>{{ usuario.pis_pasep ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          NÚMERO DO RG:
          <b>{{ usuario.rg ?? '-' }}</b>
        </td>

        <td>
          ORG. EXPEDIDOR RG:
          <b>{{ usuario.rg_org_expedidor ?? '-' }}/{{ usuario.rg_uf ?? '-' }}</b>
        </td>

        <td>
          COMPLEMENTO RG:
          <b>{{ usuario.rg_complemento ?? '-' }}</b>
        </td>

        <td>
          DATA DE EMISSÃO RG:
          <b>{{ usuario.rg_emissao ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          Nº DA CARTEIRA DE TRABALHO:
          <b>{{ usuario.ctps ?? '-' }}</b>
        </td>

        <td>
          SÉRIE:
          <b>{{ usuario.ctps_serie ?? '-' }}</b>
        </td>

        <td>
          UF:
          <b>{{ usuario.ctps_uf ?? '-' }}</b>
        </td>

        <td>
          DATA DE EMISSÃO:
          <b>{{ usuario.ctps_emissao ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          Nº TÍTULO DE ELEITOR:
          <b>{{ usuario.titulo_eleitor ?? '-' }}</b>
        </td>

        <td>
          ZONA:
          <b>{{ usuario.titulo_zona ?? '-' }}</b>
        </td>

        <td>
          SEÇÃO:
          <b>{{ usuario.titulo_secao ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          CNH (Nº REGISTRO):
          <b>{{ usuario.cnh ?? '-' }}</b>
        </td>

        <td>
          Nº FORMULÁRIO:
          <b>{{ usuario.num_formulario ?? '-' }}</b>
        </td>

        <td>
          RENACH:
          <b>{{ usuario.renach ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>BIOMETRIA INTEGRADA</b></h5>
        </th>
      </tr>
      <tr v-for="biometria in biometrias" :key="biometria.origem">
        <td colspan="2">
          INDICADOR SE PESSOA TEM CADASTRO {{ biometria.preposicao }} {{ biometria.origem }}:
          <b>{{ usuario['IN-BIOMETRIA-' + biometria.origem] ?? '-' }}</b>
        </td>
        <td colspan="2">
          DATA DA INTEGRAÇÃO DO CADASTRO {{ biometria.preposicao }} {{ biometria.origem }}:
          <b>{{ usuario['DT-INTGO-BIOMETRIA-' + biometria.origem] ?? '-' }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
  data() {
    return {
      biometrias: [
        { origem: "CIN", preposicao: "NO" },
        { origem: "CNH", preposicao: "NA" },
        { origem: "TSE", preposicao: "NO" },
      ],
    };
  },
};
</script>
